import { CompaniesForGzPackagesDataProvider } from './CompaniesForGzPackagesDataProvider';
import { PackageType } from '../../../../packages/packagesGrid/types';
import { CompaniesForPackagesInterface } from './CompaniesForPackagesInterface';

export class CompaniesForGzFratPackagesDataProvider
  extends CompaniesForGzPackagesDataProvider
  implements CompaniesForPackagesInterface
{
  public getPackageType() {
    return PackageType.Frat;
  }
}
